export default __webpack_public_path__ + "static/media/Rectangle.be22a507.svg";